import axios from "./axiosInstance";
import ApiURL from "../ApiURL";
import { getToken, setToken } from "./tokenService";

const refreshAccessToken = async () => {
  try {
    const tokens = getToken();
    if (!tokens?.refresh) throw new Error("No refresh token");

    const res = await axios.post(
      ApiURL["_refreshToken"],
      { refresh_token: tokens.refresh },
      { withCredentials: true }
    );

    const { access_token, refresh_token } = res.data;
    setToken(access_token, refresh_token);
    return access_token;
  } catch (err) {
    // Optionally: redirect to login or show auth error
    window.location.href = "/login"; // or handle gracefully
    throw err;
  }
};

export default refreshAccessToken;
